module.exports = __webpack_public_path__ + "img/off-modosc-claro.44ed7b83.svg";